import { useState } from "react";
import { Carousel } from "react-bootstrap";

const carouselItems = [
    { id: "1", src: "/images/habitnu/f_new_bg_1.jpeg", alt: "First slide" },
    { id: "2", src: "/images/habitnu/f_bg_image_2.jpg", alt: "Second slide" },
    { id: "3", src: "/images/habitnu/f_bg_image_3.jpg", alt: "Third slide" },
    { id: "4", src: "/images/habitnu/f_bg_image_4.jpg", alt: "Fourth slide" },
    { id: "5", src: "/images/habitnu/f_bg_image_5.jpg", alt: "Fifth slide" },
    { id: "6", src: "/images/habitnu/f_bg_image_6.jpg", alt: "Sixth slide" },
    { id: "7", src: "/images/habitnu/f_bg_image_7.jpg", alt: "Seventh slide" },
    { id: "8", src: "/images/habitnu/f_bg_image_8.jpg", alt: "Eigth slide" },
    { id: "10", src: "/images/habitnu/f_bg_image_10.jpg", alt: "Tenth slide" },
];

export default function HabitnuCarousel() {
    const [index, setIndex] = useState<number>(0);

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };
    return (
        <div className="habitnu-carousel">
            <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                interval={5000}
                fade
            >
                {carouselItems.map((item) => (
                    <Carousel.Item key={item.id}>
                        <img
                            src={item.src}
                            alt={item.alt}
                            className="web-layout-bg-image"
                            loading="eager"
                        />
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
}
